import React from "react";
import classes from "./Modal.module.scss";
import Backdrop from "./Backdrop";
import Icon from "@material-ui/core/Icon";
// import logoBlack from "../../../assets/jbfs-logo-black.png";
import logoJapfaFood from "../../../assets/logo-japfa-food.png";

const Modal = (props) => {
  return (
    <div>
      <Backdrop show={props.show} clicked={props.modalClosed} />
      <div
        className={classes.Modal}
        style={{
          transform: props.show ? "translateY(0)" : "translateY(-100vh)",
          opacity: props.show ? 1 : 0,
          position:
            props.customPosition !== undefined ? props.customPosition : "",
        }}
      >
        <div className={classes.Modal_close} onClick={props.modalClosed}>
          <Icon>cancel</Icon>
        </div>
        <div className={classes.Modal_wrapper}>
          <div className={classes.Modal_header}>
            {/* <div style={{textAlign: "left"}}> */}
            <img src={logoJapfaFood} alt="logoJapfaFood" width="150px" />
            {/* </div> */}
          </div>
          <div className={classes.Modal_body}>
            <div className={classes.ModalBody_icon}>
              {/*<Icon fontSize={'2'}>mark_email_read</Icon><span>{props.title}</span>*/}
              <i className="material-icons md-18">mark_email_read</i>&nbsp;
              {props.title}
            </div>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
